import axios from 'axios';

export function getPopups() {
  return axios.get(`${process.env.REACT_APP_URI}${process.env.REACT_APP_API_MAIN}/popup`);
}

export function getBanners() {
  return axios.get(`${process.env.REACT_APP_URI}${process.env.REACT_APP_API_MAIN}/banner`);
}

export function getFooterInfo() {
  return axios.get(`${process.env.REACT_APP_URI}${process.env.REACT_APP_API_MAIN}/footer`);
}

export function getMetatagInfo() {
  return axios.get(`${process.env.REACT_APP_URI}${process.env.REACT_APP_API_MAIN}/metatag`);
}

export function contactUsAsQnA(dataToSubmit) {
  return axios.post(`${process.env.REACT_APP_URI}${process.env.REACT_APP_API_MAIN}/qna`, dataToSubmit);
}

export function createReservation(dataToSubmit) {
  return axios.post(`${process.env.REACT_APP_URI}${process.env.REACT_APP_API_MAIN}/reserve-facility`, dataToSubmit);
}

export function getAvailableTime(dataToSubmit) {
  return axios.post(`${process.env.REACT_APP_URI}${process.env.REACT_APP_API_MAIN}/available`, dataToSubmit);
}
